export default __webpack_public_path__ + "static/media/faq.4cd17713.png";